import cn from 'classnames';
import { Link } from 'react-router-dom';

import { AllowAccess } from '@features/auth/ControlAccess/AllowAccess/AllowAccess.tsx';
import { CombinedSequentialId } from '@features/campaigns/shared/components/CombinedSequentialId/CombinedSequentialId.tsx';
import { getCountryFlagEmoji } from '@features/campaigns/shared/utils/getCountryFlagEmoji.ts';
import { AccessRights } from '@shared/api/commonApiInterfaces';
import commonStyles from '@shared/components/Table/Table.module.scss';
import { Permissions } from '@shared/consts/permissions.ts';
import { routePaths } from '@shared/router/routePaths';
import { Campaign } from '@shared/utils/interfaces/campaign';

import styles from './NameColumnBodyTemplate.module.scss';

interface NameColumnBodyTemplateProps {
  campaign: Campaign;
}

function NameColumnBodyTemplate({ campaign }: NameColumnBodyTemplateProps) {
  return (
    <div
      className={cn(commonStyles.columnValues, commonStyles.nameValueContainer, {
        [commonStyles.defaultCursor]: !campaign.accessRights.includes(AccessRights.READ),
      })}
    >
      {campaign.accessRights.includes(AccessRights.READ) ? (
        <Link className={commonStyles.nameValue} to={routePaths.campaignDetails.url(campaign.id)}>
          {campaign.name}
        </Link>
      ) : (
        campaign.name
      )}
      <p className={styles.nameIdValue}>
        <AllowAccess requiredPermissions={[Permissions.CAMPAIGN_FILTER_BY_COUNTRY]}>
          <span className={styles.countryFlag} aria-hidden>
            {getCountryFlagEmoji(campaign.country)}
          </span>
        </AllowAccess>
        <CombinedSequentialId
          sequentialId={campaign.sequentialId}
          billingSequentialId={campaign.billingSequentialId}
          type={campaign.type}
        />
      </p>
    </div>
  );
}

export default NameColumnBodyTemplate;
